var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"campo"},[_c('div',{staticClass:"etiq-1"},[_vm._v(_vm._s(_vm.etiqueta))]),(_vm.valor)?_c('div',[_vm._v(_vm._s(_vm.valor))]):_c('CampoVacio')],1)}
var staticRenderFns = []

export { render, staticRenderFns }